/*
 * @Author: zl
 * @Date: 2022-07-04 14:15:35
 * @LastEditTime: 2022-08-24 09:34:15
 * @LastEditors: zl
 * @Description: 智慧地图
 */
import request from '@/api/request'

export const selectProjectMapList = function (data) {
    return request({
        url: '/busProjectMap/selectProjectMapList',
        method: 'post',
        data,
    })
}

/**
 * 描述： 项目投资
 * 接口管理员： 崔北超
 * 参数：{ 
 *  }
 */
export const projectInvestment = function (data) {
    return request({
        url: '/auditPlanValue/selectOutPutValueToMap',
        method: 'post',
        data,
    })
}

/**
 * 描述：三方巡查统计
 * 接口管理员： 崔北超
 * 参数：{ 
 *  }
 */
export const projectPatrol = function (data) {
    return request({
        url: '/busProjectMap/selectAuditTripartiteInspection',
        method: 'post',
        data,
    })
}

/**
 * 描述：项目进度款统计
 * 接口管理员： 崔北超
 * 参数：{ 
 *  }
 */
export const projectProgress = function (data) {
    return request({
        url: '/busProjectMap/selectAuditSchedulePageInfo',
        method: 'post',
        data,
    })
}

/**
* 任务列表查询
*/
export const getUnitList = function (data) {
    return request({
        url: 'taskAssistant/selectTaskListForHome',
        method: 'post',
        data
    })
}

/**
* 描述：项目标段信息回显
*/
export const getSectionInfo = function (data) {
    return request({
        url: 'busProject/busPackageEcho',
        method: 'post',
        data
    })
}


/**
 * 描述：获取主体
 * 
 */
export const getLimit = function (data) {
    return request({
        url: '/busFileSummary/getLimit',
        method: 'post',
        data
    })
}


/**
 * 描述： 项目相册-列表
 * author：陈实
 * 
 */
export const selectProjectPicture = function (data) {
    return request({
        url: '/busFileSummary/selectProjectPicture',
        method: 'post',
        data
    })
}

/**
 * 描述： 项目相册-图片详情
 * author：陈实
 * 
 */
export const selectProjectPictureDetail = function (data) {
    return request({
        url: '/busFileSummary/selectProjectPictureDetail',
        method: 'post',
        data
    })
}